import { Avatar, Checkbox, CheckboxProps, Text } from '@chakra-ui/react';
import iconChekboxCircle from 'assets/icons/icon-chekbox-circle.svg';

type Props = CheckboxProps & {
  label: string,
  description: string,
  image?: string,
  hideIcon?: boolean
};

export default function CustomCheckBox({ children, label, description, image = iconChekboxCircle, hideIcon, ...props}: Props) {
  return (
    <Checkbox 
      {...props}
      colorScheme="green"
      w="full"
    >
      <Text
        as="span"
        display="flex"
        alignItems="center"
        gap="12px"
        w="full"
        color="#525866"
        fontSize="12px"
        lineHeight="133.333%"
        sx={{
          strong: {
            display: 'block',
            color: '#0A0D14',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '120%',
            letterSpacing: '-0.084px'
          }
        }}
      >
        { !hideIcon && <Avatar boxSize="32px" src={image} ignoreFallback /> }
        
        <Text as="span">
          <strong>{label}</strong>
          {description}
        </Text>
        {children}
      </Text>
      
    </Checkbox> 
  )
}
